'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActiveModal = undefined;

var _constants = require('../constants');

var setActiveModal = exports.setActiveModal = function () {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _constants.ActionTypes.SET_ACTIVE_MODAL,
    payload: {
      id: id,
      params: params
    }
  };
};